import { IAutoMapper } from "../interfaces";

export const mapChartLakeMatchLoadDetails = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MeasureDosDateRange")
    .forMember("measureCode", o => o.measureCode)
    .forMember("dosStartDate", o => o.dosStartDate)
    .forMember("dosEndDate", o => o.dosEndDate);

  automapper
    .createMap("default", "ChartLakeInputData")
    .forMember("projectId", o => o.projectId)
    .forMember("projectName", o => o.projectName)
    .forMember("dosStartDate", o => o.dosStartDate)
    .forMember("dosEndDate", o => o.dosEndDate)
    .forMember("includeWithoutDos", o => o.includeWithoutDos)
    .forMember("measureDosDateRanges", o => o.measureDosDateRanges);

  automapper
    .createMap("default", "MemberChart")
    .forMember("tenantId", o => o.tenantId)
    .forMember("chartType", o => o.chartType)
    .forMember("memberId", o => o.memberId)
    .forMember("firstName", o => o.firstName)
    .forMember("lastName", o => o.lastName)
    .forMember("dob", o => o.dob)
    .forMember("gender", o => o.gender)
    .forMember("dateOfServiceFrom", o => o.dateOfServiceFrom)
    .forMember("dateOfServiceTo", o => o.dateOfServiceTo)
    .forMember("sourceSystem", o => o.sourceSystem)
    .forMember("providerName", o => o.providerName)
    .forMember("groupName", o => o.groupName)
    .forMember("chartId", o => o.chartId)
    .forMember("trackingNumber", o => o.trackingNumber)
    .forMember("fileName", o => o.fileName)
    .forMember("totalPageCount", o => o.totalPageCount)
    .forMember("parentChaseID", o => o.parentChaseID)
    .forMember("dateOfService", o => o.dateOfService);

  automapper
    .createMap("default", "ChartLakeLoadData")
    .forMember("chaseID", o => o.chaseID)
    .forMember("masterMemberId", o => o.masterMemberId)
    .forMember("measureCode", o => o.measureCode)
    .forMember("memberSourceAliasID", o => o.memberSourceAliasID)
    .forMember("memberFirstName", o => o.memberFirstName)
    .forMember("memberLastName", o => o.memberLastName)
    .forMember("memberGender", o => o.memberGender)
    .forMember("memberDateOfBirth", o => o.memberDateOfBirth)
    .forMember("recordCount", o => o.recordCount)
    .forMember("memberChartList", o => o.memberChartList)
    .forMember("groupName", o => o.groupName)
    .forMember("chaseSourceAliasID", o => o.chaseSourceAliasID)
    .forMember("reportingStatusName", o => o.reportingStatusName)
    .forMember("serviceProviders", o => o.serviceProviders)
    .forMember("tagsText", o => o.tagsText)
    .forMember("masterDocumentSourceID", o => o.masterDocumentSourceID)
    .forMember("commentExists", o => o.commentExists);

  automapper
    .createMap("default", "ChartLakeMatchLoadDetails")
    .forMember("loadId", o => o.loadId)
    .forMember("userId", o => o.userId)
    .forMember("organizationId", o => o.organizationId)
    .forMember("projectId", o => o.projectId)
    .forMember("projectName", o => o.projectName)
    .forMember("status", o => o.status)
    .forMember("createDate", o => o.createDate)
    .forMember("completeDate", o => o.completeDate)
    .forMember("inputData", o => o.inputData)
    .forMember("loadData", o => o.loadData)
    .forMember("totalChasesInProject", o => o.totalChasesInProject)
    .forMember("totalChasesAvailableForMatch", o => o.totalChasesAvailableForMatch)
    .forMember("totalChasesWithMatchesFound", o => o.totalChasesWithMatchesFound)
    .forMember("totalChildRecords", o => o.totalChildRecords);
};
